const env = "prod"

const firebaseConfig = {
  apiKey: "AIzaSyDJpKWb91NancPt1zsIXBL5Mde1h0N67Is",
  authDomain: "conciergeapp-prod.firebaseapp.com",
  databaseURL: "https://conciergeapp-prod.firebaseio.com",
  projectId: "conciergeapp-prod",
  storageBucket: "conciergeapp-prod.appspot.com",
  messagingSenderId: "630272984019",
  appId: "1:630272984019:web:b84af94cf3abdd35c9e526",
  measurementId: "G-159YPCJWRP"
};

const backendUrl = `https://europe-west2-${firebaseConfig.projectId}.cloudfunctions.net/backend/api`;
const preauthToken = "c11e2e5b-4115-436c-bb03-6b2bda49c455";
const VAPID = "BKd4Ikc6-929ynos48V14Od8UHjC40dsF9maSE75w8blSVcRZ8lAjw2HXiU2X-um_qd2w7xkS9dT7V9YKrtO0_g"
const wpBaseUrl = "https://atalo.co/wp-json/wp/v2"
const wpUsername = "atalo_4b3f80613151c"
const wpPassword = "b5b214786ff0ccce"

export default {
  env,
  firebaseConfig,
  backendUrl,
  preauthToken,
  VAPID,
  wpBaseUrl,
  wpPassword,
  wpUsername
};
